export default "__VITE_ASSET__bb13f4d8__"